module.exports = __webpack_public_path__ + "static/img/tamara-small-logo.a7c0bec8.png";